/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios, { CancelTokenSource } from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ApiResponse | undefined,
  (requestParams: vp.InboxRejectStatusChangeRequest) => void,
  (requestParams: vp.InboxRejectStatusChangeRequest) => Promise<vp.ApiResponse>,
  () => void,
];

function usePostRejectApprovalTransaction({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.InboxRejectStatusChangeRequest>();
  const [response, setResponse] = useState<vp.ApiResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (
      requestParams: vp.InboxRejectStatusChangeRequest,
      cancelTokenSource: CancelTokenSource,
    ) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.rejectTransaction(requestParams, cancelTokenSource);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params, source);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.InboxRejectStatusChangeRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    async (requestParams: vp.InboxRejectStatusChangeRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.rejectTransaction(requestParams, source);
      setDataFetchingInfo(false);
      return res;
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostRejectApprovalTransaction);
